export default __webpack_public_path__ + "static/The Adventure_image 1@2x-22714af4d3fa267e8f7b51a73835edac.jpg";